// File: src/data/questionScreenConfigs.js
// -----------------------------------------------------------------------------
// Configurations des écrans de questions pour chaque questionnaire
// -----------------------------------------------------------------------------
import {
  createUserAnswer,
  updateUserAnswer,
  createRiasecUserAnswer,
  updateRiasecUserAnswer,
  createJourdaUserAnswer,
  updateJourdaUserAnswer,
  createImUserAnswer,
  updateImUserAnswer
} from '../api/questionnaires';

// Configuration pour le questionnaire Valeurs
export const valeursQuestionConfig = {
  // Échelle de réponse
  scaleLabels: [
    { value: 1, display: "1", label: "Pas du tout moi" },
    { value: 2, display: "2", label: "Peu moi" },
    { value: 3, display: "3", label: "Pas vraiment moi" },
    { value: 4, display: "4", label: "Un peu moi" },
    { value: 5, display: "5", label: "Assez moi" },
    { value: 6, display: "6", label: "Tout à fait moi" }
  ],

  // Afficher "Question X" au dessus de la question
  showQuestionNumber: false,

  // Clé pour mapper les réponses existantes (ex: ciaov2_values_survey_id)
  answerQuestionIdKey: 'ciaov2_values_survey_id',

  // Fonctions API pour créer/mettre à jour les réponses
  createAnswer: ({ userId, questionId, answer }) => createUserAnswer({
    ciaov2_user_id: userId,
    ciaov2_values_survey_id: questionId,
    answer
  }),
  updateAnswer: updateUserAnswer,

  // Fonction pour récupérer le texte de la question
  // Retourne le texte selon le genre (boy/girl)
  getQuestionText: (question, gender) => {
    if (!question) return '';
    return gender === 'boy' ? question.text_m : question.text_f;
  },

  // Largeur max de la zone de scale
  scaleMaxWidth: '400px',

  // Classes CSS pour le bouton sélectionné
  selectedClassName: 'bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-lg shadow-indigo-500/30 scale-110'
};

// Configuration pour le questionnaire RIASEC
export const riasecQuestionConfig = {
  // Échelle de réponse
  scaleLabels: [
    { value: 1, display: '<svg viewBox="0 0 36 36"><circle cx="18" cy="18" r="16" fill="currentColor" opacity="0.15"/><path d="M9 10 L14 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M27 10 L22 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M10 15 L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M21 15 L26 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M10 24 L14 22 L18 25 L22 22 L26 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>', label: "Je détesterais" },
    { value: 2, display: '<svg viewBox="0 0 36 36"><circle cx="18" cy="18" r="16" fill="currentColor" opacity="0.15"/><path d="M9 12 L15 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M27 12 L21 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M10 16 Q12.5 14 15 16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><path d="M21 16 Q23.5 14 26 16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><path d="M13 23 Q18 20 23 23" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>', label: "Je n'aimerais pas" },
    { value: 3, display: '<svg viewBox="0 0 36 36"><circle cx="18" cy="18" r="16" fill="currentColor" opacity="0.15"/><path d="M9 13 L15 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M21 11 L27 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="16" r="2" fill="currentColor"/><circle cx="24" cy="15" r="2.5" fill="currentColor"/><path d="M12 23 Q15 22 18 23 Q21 24 24 23" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>', label: "Je ne sais pas" },
    { value: 4, display: '<svg viewBox="0 0 36 36"><circle cx="18" cy="18" r="16" fill="currentColor" opacity="0.15"/><path d="M9 15 Q12 12 15 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><path d="M21 15 Q24 12 27 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/><circle cx="8" cy="19" r="2.5" fill="currentColor" opacity="0.2"/><circle cx="28" cy="19" r="2.5" fill="currentColor" opacity="0.2"/><path d="M11 21 Q18 27 25 21" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>', label: "J'aimerais" },
    { value: 5, display: '<svg viewBox="0 0 36 36"><circle cx="18" cy="18" r="16" fill="currentColor" opacity="0.12"/><path d="M18 2 L18 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/><path d="M28 6 L26 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/><path d="M8 6 L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/><path d="M12 14 L13 12 L14 14 L16 13 L14 14 L15 16 L13 15 L11 16 L12 14 L10 13 Z" fill="currentColor"/><path d="M24 14 L25 12 L26 14 L28 13 L26 14 L27 16 L25 15 L23 16 L24 14 L22 13 Z" fill="currentColor"/><path d="M10 20 Q18 30 26 20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round"/><path d="M10 20 Q18 22 26 20" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.3"/></svg>', label: "J'adorerais" }
  ],

  // Pas d'affichage "Question X" pour RIASEC
  showQuestionNumber: false,

  // Clé pour mapper les réponses existantes
  answerQuestionIdKey: 'ciaov2_riasec_survey_id',

  // Fonctions API pour créer/mettre à jour les réponses
  createAnswer: ({ userId, questionId, answer }) => createRiasecUserAnswer({
    ciaov2_user_id: userId,
    ciaov2_riasec_survey_id: questionId,
    answer
  }),
  updateAnswer: updateRiasecUserAnswer,

  // Fonction pour récupérer le texte de la question
  // RIASEC utilise un champ "text" unique (pas de genre)
  getQuestionText: (question) => {
    if (!question) return '';
    return question.text;
  },

  // Largeur max de la zone de scale
  scaleMaxWidth: '320px',

  // Classes CSS pour le bouton sélectionné (style RIASEC avec bordure violet)
  selectedClassName: 'border border-violet-500 bg-violet-500/20 scale-110'
};

// Configuration pour le questionnaire Jourda
// Note: Les réponses viennent de l'API pour chaque question (question.answers)
export const jourdaQuestionConfig = {
  // Pas de scaleLabels statique - ils viennent de l'API (question.answers)
  scaleLabels: null,

  // Indique que les propositions sont dynamiques (viennent de la question)
  dynamicPropositions: true,

  // Pas d'affichage "Question X" pour Jourda
  showQuestionNumber: false,

  // Clé pour mapper les réponses existantes
  answerQuestionIdKey: 'ciaov2_jourda_survey_id',

  // Fonctions API pour créer/mettre à jour les réponses
  // answer = la lettre choisie (A, B, C, D)
  createAnswer: ({ userId, questionId, answer }) => createJourdaUserAnswer({
    ciaov2_user_id: userId,
    ciaov2_jourda_survey_id: questionId,
    answer
  }),
  updateAnswer: updateJourdaUserAnswer,

  // Fonction pour récupérer le texte de la question
  getQuestionText: (question) => {
    if (!question) return '';
    return question.text || "Que préfères-tu ?";
  },

  // Fonction pour récupérer les réponses dynamiques de la question
  // Retourne un tableau avec { value: letter, display: text, label: text }
  getAnswers: (question) => {
    if (!question?.answers) return [];
    return question.answers.map(answer => ({
      value: answer.letter,
      display: answer.letter,
      label: answer.text
    }));
  },

  // Largeur max de la zone de réponses
  scaleMaxWidth: '400px',

  // Max width pour chaque bouton
  buttonMaxWidth: '400px',

  // Classes CSS pour le bouton sélectionné
  selectedClassName: 'border-2 border-indigo-500 bg-indigo-500/20'
};

// Configuration pour le questionnaire Intelligences Multiples (IM)
export const imQuestionConfig = {
  // Échelle de réponse (1 à 5)
  scaleLabels: [
    { value: 1, display: "1", label: "Pas du tout moi" },
    { value: 2, display: "2", label: "Plutôt pas moi" },
    { value: 3, display: "3", label: "Ça dépend" },
    { value: 4, display: "4", label: "Plutôt moi" },
    { value: 5, display: "5", label: "Tout à fait moi" }
  ],

  // Afficher "Question X" au dessus de la question
  showQuestionNumber: false,

  // Clé pour mapper les réponses existantes
  answerQuestionIdKey: 'ciaov2_im_survey_id',

  // Fonctions API pour créer/mettre à jour les réponses
  createAnswer: ({ userId, questionId, answer }) => createImUserAnswer({
    ciaov2_user_id: userId,
    ciaov2_im_survey_id: questionId,
    answer
  }),
  updateAnswer: updateImUserAnswer,

  // Fonction pour récupérer le texte de la question
  // IM utilise un champ "text" unique (pas de genre)
  getQuestionText: (question) => {
    if (!question) return '';
    return question.text;
  },

  // Largeur max de la zone de scale
  scaleMaxWidth: '320px',

  // Classes CSS pour le bouton sélectionné
  selectedClassName: 'bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-lg shadow-indigo-500/30 scale-110'
};
